/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_SalesChannelUpdateRequest = {
    config?: any;
    description?: Record<string, string>;
    enabled?: boolean;
    name: Record<string, string>;
    position?: number;
    type: models_SalesChannelUpdateRequest.type;
};
export namespace models_SalesChannelUpdateRequest {
    export enum type {
        WEB = 'web',
        POS = 'pos',
        AGENCY = 'agency',
        MARKETING = 'marketing',
        VNPAY = 'vnpay',
        ZALOPAY = 'zalopay',
    }
}

